import { IQuickFormOption } from '@app/reports/report-settings/shared/quick-form-option.interface';

export class QuickFormOption implements IQuickFormOption {
  id: string;
  name: string;
  visible: boolean;
  selected: boolean;
  legacy: boolean;
  object: string;

  constructor() {
    this.object = 'quickFormOption';
  }
}
